import Vue from "vue";
import Vuex from "vuex";
import offici from "./officialAccount/offici";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    offici,
  },
});
